'use client';
import React from 'react';
import styles from './SimpleHeaderBar.module.scss';

export const SimpleHeaderBar: React.FC = () => {
  return <div className={`${styles.wrapper} px-5 flex items-center justify-end`}>{/* <SimpleAccount /> */}</div>;
};
